module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-page",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "question-header"
  }, [_c('h2', [_vm._v("#" + _vm._s(_vm.currentIndex + 1) + "/" + _vm._s(_vm.questionList.length))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.getPercent((_vm.currentIndex + 1), _vm.questionList.length)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "question-body"
  }, [_c('QuestionItem', {
    ref: "questionItem",
    attrs: {
      "item": _vm.getCurrentQuestion()
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-footer"
  }, [(_vm.hasHistory()) ? _c('div', {
    staticClass: "next-question prev",
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "next-question",
    on: {
      "click": function($event) {
        _vm.goNext()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-132b568a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey-detail.vue
// module id = 271
// module chunks = 1